export function isDefined(val: any, checkEmptyString = false) {
    if (checkEmptyString && val === '') {
        return false;
    }
    return val !== undefined && val !== null;
}
